var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVersus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7127 18.3885C18.4258 18.6754 18.2628 19.0359 18.2111 19.4093L13.9023 15.1006L15.4248 13.5781L19.7335 17.8869C19.3604 17.9389 18.9996 18.1016 18.7127 18.3885Z",
    fill: "#DCDCDC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.511 20.9791C20.5019 20.9791 21.3052 20.1758 21.3052 19.1848C21.3052 18.1939 20.5019 17.3906 19.511 17.3906C18.5201 17.3906 17.7168 18.1939 17.7168 19.1848C17.7168 20.1758 18.5201 20.9791 19.511 20.9791Z",
    fill: "#ABABAB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.232 12.303L3.52532 0.662654L0.480469 0.155273L0.988175 3.20013L12.6945 14.8405L15.232 12.303Z",
    fill: "url(#paint0_linear_2676_2679)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.07453 18.3885C3.36141 18.6754 3.52444 19.0359 3.57614 19.4093L7.88489 15.1006L6.36246 13.5781L2.05371 17.8868C2.42678 17.9389 2.78761 18.1016 3.07453 18.3885Z",
    fill: "#DCDCDC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.27469 20.9791C3.2656 20.9791 4.0689 20.1758 4.0689 19.1848C4.0689 18.1939 3.2656 17.3906 2.27469 17.3906C1.28377 17.3906 0.480469 18.1939 0.480469 19.1848C0.480469 20.1758 1.28377 20.9791 2.27469 20.9791Z",
    fill: "#ABABAB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75175 15.2481L6.21387 12.7103L18.2619 0.662654L21.3067 0.155273L20.7994 3.20013L8.75175 15.2481Z",
    fill: "url(#paint1_linear_2676_2679)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4228 16.6502L16.9754 13.0976V11.5752H15.453L11.9004 15.1278V16.6502H13.4228Z",
    fill: "#ABABAB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36603 16.6502L4.81348 13.0976V11.5752H6.3359L9.88846 15.1278V16.6502H8.36603Z",
    fill: "#ABABAB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2676_2679",
    x1: 6.31714,
    y1: 4.71202,
    x2: 19.287,
    y2: 19.5202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2676_2679",
    x1: 12.1856,
    y1: 4.8385,
    x2: 21.4104,
    y2: 14.0626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5CDFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersus);
export default __webpack_public_path__ + "static/media/versus.6b1a10f8d0268861c5db817f6b46a07d.svg";
export { ForwardRef as ReactComponent };